import React from 'react';

// Prazo de entrega do processo (o que evita a multa).
// O prazo é a PRÓPRIA data do evento: tem de estar pronto até o dia da admissão
// e até o dia da rescisão. O badge só some quando não há data.
const CORES = {
  entregue: { bg: '#e6f7ef', cor: '#116b47', borda: '#a8dcc3', icone: 'fa-circle-check' },
  ok: { bg: '#eef2f7', cor: '#00205b', borda: '#d6dee8', icone: 'fa-clock' },
  alerta: { bg: '#fff5da', cor: '#8a6d00', borda: '#f0dfa8', icone: 'fa-triangle-exclamation' },
  // 2 dias ou menos para o limite: vermelho, ainda dá para virar o jogo hoje
  critico: { bg: '#fdeaec', cor: '#a11d2b', borda: '#f3b8bf', icone: 'fa-triangle-exclamation' },
  hoje: { bg: '#ffe8cc', cor: '#b5560e', borda: '#f5c99b', icone: 'fa-bell' },
  atrasado: { bg: '#fdeaec', cor: '#a11d2b', borda: '#f3b8bf', icone: 'fa-circle-exclamation' },
};

const texto = (p) => {
  if (p.situacao === 'entregue') return 'entregue';
  if (p.situacao === 'atrasado') {
    const d = Math.abs(p.dias);
    return `atrasado ${d} dia${d === 1 ? '' : 's'}`;
  }
  if (p.situacao === 'hoje') return 'vence hoje';
  return `faltam ${p.dias} dia${p.dias === 1 ? '' : 's'}`;
};

const PrazoBadge = ({ prazo }) => {
  if (!prazo) {
    return (
      <span className="text-muted" title="Sem data para cobrar prazo">-</span>
    );
  }
  const e = CORES[prazo.situacao] || CORES.ok;
  const detalhe = prazo.situacao === 'entregue'
    ? `Entregue${prazo.entregue_em ? ` em ${prazo.entregue_em}` : ''} · prazo era ${prazo.limite}`
    : `Precisa estar pronto até ${prazo.limite}${prazo.rotulo ? ` (${prazo.rotulo})` : ''}`;
  return (
    <span className="badge" title={detalhe}
      style={{
        background: e.bg, color: e.cor, border: `1px solid ${e.borda}`,
        fontWeight: 600, whiteSpace: 'nowrap',
      }}>
      <i className={`fas ${e.icone} me-1`}></i>{texto(prazo)}
    </span>
  );
};

export default PrazoBadge;
